// extracted by mini-css-extract-plugin
export default {"countCell":"_2awlArsodLhnDZRzoXEl8g"};